

















import { Component, Vue, Prop } from "vue-property-decorator";
import SimpleDialogForm from "@/components/Forms/SimpleDialogForm.vue";
import TextMultiline from "@/components/Forms/TextMultiline.vue";

@Component({ components: { TextMultiline, SimpleDialogForm } })
export default class NoteCreationDialog extends Vue {
  @Prop(Boolean) readonly value: boolean = false;

  note = "";
  get isFormValid(): boolean {
    return this.note.trim().length >= 1 && this.note.length <= 1000;
  }

  close() {
    this.$emit("input", false);
  }

  save() {
    this.$emit("onSave", this.note);
    this.note = "";
  }

  get canSave() {
    return this.note && this.note.trim().length >= 1 && this.note.length <= 1000;
  }

  onLoadDetailsError() {
    this.$emit("input", false);
  }
}
